import { autofillForm, createResponse } from '~/lib/client';
import { getClearbitAnonymousID, getSegmentAnonymousID } from '~/lib/helpers';

import Field from './Field';

class Form extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      autofilling: false,
    };
  }

  setResponse(response) {
    this.setState({ response });
  }

  getFields() {
    let refs = Object.values(this.refs);
    refs = refs.filter((ref) => ref.getValue);
    return refs;
  }

  getFieldsForType(type) {
    return this.getFields().filter((node) => node.getField().type === type);
  }

  getFieldIDValues() {
    let fields = this.getFields();
    let values = {};

    fields.forEach((item) => {
      values[item.getField().id] = item.getValue();
    });

    return values;
  }

  getActionLabel() {
    let form = this.props.form;

    if (this.state.pending || this.state.submitClicked) {
      return 'Submitting...';
    } else {
      return form.action_label || 'Submit';
    }
  }

  getEmailField() {
    let fields = this.getFields();
    let emailField = fields.find((field) => field.isEmail());

    return emailField;
  }

  getParams() {
    let result = {};

    const anonymousID = getClearbitAnonymousID() || getSegmentAnonymousID();

    if (anonymousID) {
      result.anonymous_id = anonymousID;
    }

    if (this.props.params) {
      Object.assign(result, this.props.params);
    }

    return result;
  }

  isValid() {
    let fields = this.getFields();

    let invalidFields = fields.filter((field) => !field.isValid());

    if (invalidFields.length) return false;

    return true;
  }

  setAutofill = (autofill) => {
    this.setState({ autofill });

    let key;

    for (key in autofill) {
      let value = autofill[key];
      let nodes = this.getFieldsForType(key);

      nodes = nodes.filter((node) => node.shouldAutofill());
      nodes.forEach((node) => node.setAutofillValue(value));
    }
  };

  getButtonClass() {
    return classnames({
      'cb-button': true,
      'cb-pending': this.state.pending,
    });
  }

  onBlurField(field) {
    if (!field.isEmail()) return;
    if (!field.getValue()) return;
    if (!field.isValid()) return;

    field.isValidEmail().then((result) => {
      if (result === false) {
        throw new Error('invalid email');
      }

      this.setState({ autofilling: true });

      autofillForm(this.props.form.id, field.getValue())
        .then(this.setAutofill)
        .then(() => {
          this.setState({ autofilling: false });
          if (this.state.submitClicked) {
            this.onSubmit();
          }
        });
    });
  }

  onResponse(response) {
    this.props.onResponse && this.props.onResponse(response);

    this.setState({ response });

    let form = this.props.form;

    if (form.action_url) {
      window.location = form.action_url;
    }
  }

  onSubmit() {
    const { autofilling, pending } = this.state;

    if (autofilling) return;

    if (pending || !this.isValid()) {
      this.setState({ submitClicked: false });
      return;
    }

    this.setState({ pending: true });

    let form = this.props.form;

    let params = {
      form_id: form.id,
      values: this.getFieldIDValues(),
    };

    Object.assign(params, this.getParams());

    createResponse(params)
      .then((response) => {
        this.setState({ pending: false });
        this.onResponse(response);
      })
      .catch(this.onError.bind(this));
  }

  onError(response) {
    const message = response.error.message;
    alert(message);
  }

  onFormSubmit(e) {
    e.preventDefault();
    this.onSubmit();
  }

  renderField(field) {
    return (
      <Field
        field={field}
        key={field.id}
        ref={`field-${field.id}`}
        theme={this.props.theme}
        email={this.props.email}
        onBlur={this.onBlurField.bind(this)}
      />
    );
  }

  renderFields() {
    return this.props.form.fields.map(this.renderField.bind(this));
  }

  renderSubmit() {
    return (
      <div className="cb-submit">
        <button
          type="submit"
          className={this.getButtonClass()}
          onMouseDown={() => this.setState({ submitClicked: true })}>
          {this.getActionLabel()}
        </button>
      </div>
    );
  }

  renderTitle() {
    const { form } = this.props;

    if (!form.title) return;
    if (!form.title.length) return;

    return <h2>{form.title}</h2>;
  }

  renderLinkAttribution() {
    return (
      <div className="cb-attribution">
        <a
          href="https://clearbit.com"
          target="_blank"
          rel="noopener noreferrer">
          Powered by Clearbit
        </a>
      </div>
    );
  }

  renderForm() {
    const { form } = this.props;

    return (
      <div className="cb-form">
        {this.renderTitle()}

        <form
          onSubmit={this.onFormSubmit.bind(this)}
          onInvalid={() => {
            this.setState({ submitClicked: false });
          }}>
          {this.renderFields()}
          {this.renderSubmit()}
        </form>

        {form.link_attribution && this.renderLinkAttribution()}
      </div>
    );
  }

  renderResponse() {
    let form = this.props.form;

    return (
      <div className="cb-response">
        <p>{form.success_message || 'Thank you!'}</p>
      </div>
    );
  }

  render() {
    let response = this.state.response;

    return response ? this.renderResponse() : this.renderForm();
  }
}

Form.propTypes = {
  form: PropTypes.object,
  theme: PropTypes.object,
  email: PropTypes.string,
  params: PropTypes.object,
  onResponse: PropTypes.func,
};

export default Form;
